import classNames from "classnames";
import styles from "./ColumnButton.module.css";
import { FunctionComponent, PropsWithChildren } from "react";

type TProps = {
  onClick: () => void;
  isActive: boolean;
  disabled?: boolean;
  className?: string;
};

const ColumnButton: FunctionComponent<PropsWithChildren<TProps>> = (props) => (
  <button
    className={classNames(
      styles.columnButton,
      {
        [styles.active]: props.isActive,
        [styles.disabled]: props.disabled,
      },
      props.className
    )}
    onClick={props.onClick}
    disabled={props.disabled}
  >
    {props.children}
  </button>
);

export default ColumnButton;
